module.exports = __webpack_public_path__ + "img/main_02.12023c6f.png";